import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { LoadingIndicatorService } from '../services/loading-indicator.service';

@Injectable()
export class LoadingIndicatorInterceptor implements HttpInterceptor {

  constructor(private loadingIndicatorService: LoadingIndicatorService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.loadingIndicatorService.onStarted(request);

    return next.handle(request)
      .finally(() => this.loadingIndicatorService.onFinished(request));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/loading-indicator.interceptor.ts